module.exports = __webpack_public_path__ + "media/images/common/arrow-red-25df2ea50e5d28feb83ef04324568f7d.svg";